export enum Action {
  BLOCK = "BLOCK",
  REPORT = "REPORT",
  DELETE = "DELETE",
}
